// @flow
import * as React from 'react';
import styled from 'styled-components';
import Check2 from 'react-bootstrap-icons/dist/icons/check2';
import TextHeader2 from './TextHeader2';
import TextParagraph from './TextParagraph';
import Container from './Container';

type TProps = {
  items: Array<{ title: string, description: string }>,
};

const UnorderedList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 auto;
  justify-content: center;
  display: flex;
  flex-direction: column;
  max-width: 600px;
  margin-top: 1.6rem;
`;

const ListItem = styled.li`
  display: inline-grid;
  grid-gap: 0.4rem;
  grid-template-columns: 2rem auto;
`;


export default function Checklist(props: TProps): React.Node {
  return (
    <UnorderedList>
      {props.items.map(item => (
        <ListItem key={item.title}>
          <Check2 size={22} />
          <Container>
            <TextHeader2>{item.title}</TextHeader2>
            <TextParagraph>{item.description}</TextParagraph>
          </Container>
        </ListItem>
      ))}
    </UnorderedList>
  );
}
